module.exports = __webpack_public_path__ + "static/media/do.2e442413.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/do.svg
// module id = 102
// module chunks = 0